{
  "slug": "what-is-iq",
  "title": "¿Qué es el coeficiente intelectual?",
  "description": "Aprenda qué significa el coeficiente intelectual, qué mide un test de coeficiente intelectual y los límites importantes de las puntuaciones del coeficiente de inteligencia.",
  "summary": "El coeficiente intelectual (CI), abreviatura de cociente de inteligencia, es una puntuación estandarizada diseñada para describir el rendimiento en tareas cognitivas seleccionadas en comparación con personas de una edad similar.",
  "sections": [
    {
      "heading": "Qué representa un puntaje de CI",
      "paragraphs": [
        "Las pruebas de coeficiente intelectual modernas combinan los resultados de tareas cuidadosamente diseñadas y los comparan con un grupo de referencia representativo. 100, por lo que un resultado describe el rendimiento relativo en lugar de una cantidad absoluta de inteligencia.",
        "Las condiciones de la prueba, la salud, el idioma, la motivación, la familiaridad con los formatos de prueba y el error normal de medición pueden afectar el resultado, por lo que es importante que el estudiante sea consciente de los factores que pueden influir en el resultado."
      ]
    },
    {
      "heading": "Qué evalúan comúnmente las pruebas de CI",
      "paragraphs": [
        "Las baterías profesionales muestran varias habilidades cognitivas en lugar de depender de un tipo de rompecabezas."
      ],
      "bullets": [
        "Comprensión verbal y conocimientos adquiridos",
        "Razonamiento visual-espacial y fluido",
        "Memoria de trabajo y atención",
        "Velocidad de procesamiento"
      ]
    },
    {
      "heading": "Lo que el CI no mide",
      "paragraphs": [
        "El coeficiente intelectual no capta completamente la creatividad, el juicio práctico, la curiosidad, las habilidades emocionales, la motivación, la sabiduría o el conocimiento especializado, y no puede determinar el valor o el futuro de una persona.",
        "Una evaluación supervisada por un profesional calificado es más adecuada para decisiones clínicas, educativas o legales, mientras que un resultado de tipo QI en línea debe seguir siendo indicativo."
      ]
    }
  ],
  "faqs": [
    {
      "question": "¿Qué significa IQ?",
      "answer": "El CI es la abreviatura de cociente de inteligencia, una puntuación estandarizada que compara el rendimiento cognitivo seleccionado con un grupo de referencia basado en la edad."
    },
    {
      "question": "¿Es un diagnóstico un test de CI en línea?",
      "answer": "Los resultados en línea son estimaciones y no deben reemplazar una evaluación por un profesional calificado."
    }
  ],
  "related": ["how-is-iq-measured", "iq-vs-intelligence", "what-is-the-average-iq"]
}
